import React from 'react';
import PlanAwareLink from '../billing/PlanAwareLink';
import { LuBell, LuInbox } from 'react-icons/lu';
import { useTeamContextOptional } from '../../context/TeamContext';
import TeamRequestList from './TeamRequestList';

/**
 * Workspace, assignment, and challenge invites for the current user (global inbox).
 */
export default function TeamGlobalRequestsPanel({
  showWhenEmpty = false,
  compact = false,
  hideTeamsLink = false,
}) {
  const team = useTeamContextOptional();
  const pendingCount = team?.pendingRequestCount ?? 0;
  const items = team?.pendingInbox?.items ?? [];

  if (!team?.access?.teamsEnabled && pendingCount === 0 && !showWhenEmpty) {
    return null;
  }

  if (pendingCount === 0 && !showWhenEmpty) {
    return null;
  }

  if (compact && pendingCount === 0 && showWhenEmpty) {
    return (
      <p className="teams-inbox-empty-line" role="status">
        You&apos;re all caught up.
      </p>
    );
  }

  return (
    <div className={`teams-card teams-global-inbox ${compact ? 'teams-global-inbox--compact' : ''}`}>
      <div className="teams-notifications-head">
        <h3 className="teams-section-title">
          {pendingCount > 0 ? <LuBell aria-hidden /> : <LuInbox aria-hidden />}
          Pending requests
          {pendingCount > 0 && <span className="teams-nav-badge">{pendingCount}</span>}
        </h3>
      </div>
      <p className="teams-sub teams-section-lead">
        {pendingCount > 0
          ? 'Accept workspace invites or assignment/challenge requests below.'
          : 'When someone invites you to a team or assignment, it will show up here.'}
      </p>
      {pendingCount > 0 ? (
        <TeamRequestList
          prefetched={items}
          status="PENDING"
          compact={compact}
          onUpdated={() => {
            team?.refreshPendingInbox?.();
            team?.refresh?.();
          }}
          emptyMessage="No pending requests."
        />
      ) : (
        <p className="teams-sub">You&apos;re all caught up.</p>
      )}
      {pendingCount > 0 && items.some((r) => r.requestType === 'WORKSPACE' && r.organizationId) && (
        <p className="teams-sub">
          After accepting a workspace invite, open that team from the list below.
        </p>
      )}
      {!compact && !hideTeamsLink && (
        <PlanAwareLink to="/teams" className="teams-btn teams-btn--secondary teams-notifications-all">
          Teams home
        </PlanAwareLink>
      )}
    </div>
  );
}
